import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index'
import building_routes from './building'
import tools_routes from './tools'
import packageA_routes from './packageA'
import packageB_routes from './packageB'
import personal_package_routes from './personal_package'
import list_routes from './list'
import chat from './chat'
import activity_a_routes from './activity_a'
import consultants_routes from './consultants'
import tmhf from './tmhf'

Vue.use(VueRouter)

const routes = [
    {
        path: '',
        name: 'Home',
        component: Home
    },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/index',
        name: 'Home',
        component: Home
    },
    {
        path: '/all_buildings',
        name: 'AllBuildings',
        component: () => import(/* webpackChunkName: "tabbar" */ '../views/all_buildings/main.vue')
    },
    {
        path: '/messages',
        name: 'Messages',
        component: () => import(/* webpackChunkName: "tabbar" */ '../views/messages/main.vue')
    },
    {
        path: '/personal_center',
        name: 'PersonalCenter',
        component: () => import(/* webpackChunkName: "tabbar" */ '../views/personal_center/main.vue')
    },
    {
        path: '/search',
        name: 'search',
        component: () => import(/* webpackChunkName: "tabbar" */ '../views/search/index.vue')
    },
    {
        path: '/hot',
        name: 'hot',
        component: () => import(/* webpackChunkName: "about" */ '../views/list/hot.vue')
    },
    {
        path: '/list/web_720',
        name: 'web_720',
        component: () => import(/* webpackChunkName: "about" */ '../views/list/web_720/main.vue')
    },
    {
        path: '/list/vr',
        name: 'vr',
        component: () => import(/* webpackChunkName: "about" */ '../views/list/vr/main.vue')
    },
    {
        path: '/forthcoming_sale',
        name: 'forthcoming_sale',
        component: () => import(/* webpackChunkName: "about" */ '../views/list/forthcoming_sale/index.vue')
    },
    {
        path: '/surplus',
        name: 'surplus',
        component: () => import(/* webpackChunkName: "about" */ '../views/list/surplus/index.vue')
    },
    {
        path: '/list',
        name: 'list',
        component: () => import(/* webpackChunkName: "about" */ '../views/list/index.vue')
    },
    {
        path: '/guide',
        name: 'guide',
        component: () => import(/* webpackChunkName: "guide" */ '../views/guide/index.vue')
    },
    {
        path: '/material',
        name: 'material',
        component: () => import(/* webpackChunkName: "material" */ '../views/guide/material.vue')
    },
    {
        path: '/order_check/index',
        name: 'order_check',
        component: () => import(/* webpackChunkName: "order_check" */ '../views/order_check/main.vue')
    },
    {
        path: '/order_check/verify',
        name: 'order_check_verify',
        component: () => import(/* webpackChunkName: "order_check" */ '../views/order_check/verify.vue')
    },
    {
        path: '/verify_list',
        name: 'verify_list',
        component: () => import(/* webpackChunkName: "about" */ '../views/verify_list/index.vue')
    },
    {
        path: '/map_buildings',
        name: 'map_buildings',
        component: () => import(/* webpackChunkName: "about" */ '../views/whole_buildings_map/index.vue')
    },
    {
        path: '/logging_in',
        name: 'logging_in',
        component: () => import(/* webpackChunkName: "about" */ '../views/logging_in/main.vue')
    },
    {
        path: '/result/main',
        name: 'result/main',
        component: () => import(/* webpackChunkName: "about" */ '../views/result/main')
    },
    {
        path: '/reg_step/main',
        name: 'reg_step/main',
        component: () => import(/* webpackChunkName: "about" */ '../views/reg_step/main')
    },
    {
        path: '/result/search/main',
        name: 'result/search/main',
        component: () => import(/* webpackChunkName: "about" */ '../views/result/search/main')
    },
    {
        path: '/web_page',
        name: 'web_page',
        component: () => import(/* webpackChunkName: "about" */ '../views/web_page/main')
    },
    {
        path: '/protocal/privacy',
        name: 'protocal_privacy',
        component: () => import(/* webpackChunkName: "protocal" */ '../views/protocal/privacy')
    },
    {
        path: '/protocal/user',
        name: 'protocal_user',
        component: () => import(/* webpackChunkName: "protocal" */ '../views/protocal/user')
    },
    {
        path: '/mp/policy',
        name: 'mp/policy',
        component: () => import(/* webpackChunkName: "mp" */ '../views/mp/policy')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return (
            savedPosition || {
                x: 0,
                y: 9
            }
        )
    }
})

router.addRoutes(building_routes)
router.addRoutes(tools_routes)
router.addRoutes(packageA_routes)
router.addRoutes(packageB_routes)
router.addRoutes(personal_package_routes)
router.addRoutes(activity_a_routes)
router.addRoutes(list_routes)
router.addRoutes(chat)
router.addRoutes(consultants_routes)

router.addRoutes(tmhf)

export default router
